/**
 * The websocket to the server has changed state.
 *
 * @public
 * @memberof connection
 * @event ws:change
 * @param {Object} params
 * @param {string} params.platform The platform
 */
export const WS_CHANGE = 'ws:change'
